/**
 * VSPC UI API
 * Internal API
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum JobTypeRepresentation {
    Unknown = 'unknown',
    Backup = 'backup',
    Replica = 'replica',
    VmCopy = 'vmCopy',
    FileCopy = 'fileCopy',
    FileTapeBackup = 'fileTapeBackup',
    VmTapeBackup = 'vmTapeBackup',
    BackupCopy = 'backupCopy',
    SqlLogBackup = 'sqlLogBackup',
    OracleLogBackup = 'oracleLogBackup',
    SureBackup = 'sureBackup',
    CdpReplica = 'cdpReplica',
    VcdReplica = 'vcdReplica',
    EndpointJob = 'endpointJob',
    AgentBackupJob = 'agentBackupJob',
    AgentPolicy = 'agentPolicy',
    AgentBackupJobDefinition = 'agentBackupJobDefinition',
    Nas = 'nas',
    NasBackupCopy = 'nasBackupCopy',
    PolicySnapshot = 'policySnapshot',
    PolicyBackup = 'policyBackup',
    PolicyRemoteSnapshot = 'policyRemoteSnapshot',
    SnapshotJob = 'snapshotJob',
    PostgreSqlLogBackup = 'postgreSqlLogBackup',
    ObjectStorageBackup = 'objectStorageBackup',
    ObjectStorageBackupCopy = 'objectStorageBackupCopy'
};

